import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import css from './FieldCheckboxImage.module.css';

const FieldCheckboxImage = props => {
  const {
    rootClassName,
    className,
    svgClassName,
    textClassName,
    id,
    label,
    useSuccessColor,
    image,
    ...rest
  } = props;

  const Icon = image;

  const classes = classNames(rootClassName || css.root, className);

  // This is a workaround for a bug in Firefox & React Final Form.
  // https://github.com/final-form/react-final-form/issues/134
  const handleOnChange = (input, event) => {
    const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);

    // If onChange has been passed as a props to FieldCheckboxImage
    if (rest.onChange) {
      rest.onChange(event);
    }
  };

  return (
    <span className={classes}>
      <Field type="checkbox" {...rest}>
        {props => {
          const { input, disabled } = props;
          return (
            <input
              id={id}
              className={css.input}
              {...input}
              onChange={event => handleOnChange(input, event)}
              disabled={disabled}
            />
          );
        }}
      </Field>
      <label htmlFor={id} className={css.label}>
        <span className={css.checkboxWrapper}>
          <div className={css.imageContainer}>
            {/* <img className={css.icon} src={image} /> */}
            <Icon
              className={css.icon}
              viewBox="0 0 500 500"
            />
          </div>
          <span className={classNames(css.text, textClassName || css.textRoot)}>{label}</span>
        </span>
      </label>
    </span>
  );
};

export default FieldCheckboxImage;
